import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Container, Grid } from '@mantine/core';
import { Link } from 'react-router-dom';
import { MantineReactTable } from 'mantine-react-table';
import './location1.css'
import Swal from 'sweetalert2';
import { getOrgId, getUserId, DeleteExternalUser, AddExtrnalUser, GetExternalUser, GetLeavePolicy, HEADERS, GetDepartment, EditExternalUser } from '../../api';
import axios from 'axios';

export default function AddExternalUser() {
  const [data, setData] = useState([]);
  // const [buttonClicked, setButtonClicked] = useState(false);
  const [ExternalUser, setExtUser] = useState([]);
  const [LeavePolicy, setLeavePolicy] = useState([]);
  const [departments, setDepartment] = useState([]);
  const [editExternalUser, setExternalUser] = useState([]);


  // for departments
  const Element = document.createElement('select');
  Element.id = 'department';
  // Add options to the select element
  departments.forEach(optionText => {
    const option = document.createElement('option');
    option.text = option.value = optionText;
    Element.add(option);
  });

  // for leave pilocy
  const selectElement = document.createElement('select');
  selectElement.id = 'leavepolicy';
  // Add options to the select element
  LeavePolicy.forEach(optionText => {
    const option = document.createElement('option');
    option.text = option.value = optionText;
    selectElement.add(option);
  });

  const AddExternalUsers = async () => {
    const { value: formValues, isConfirmed } = await Swal.fire({
      title: 'Add External User',
      showCancelButton: true,
      confirmButtonText: 'Add',
      cancelButtonText: 'Cancel',
      reverseButtons: 'true',
      html: `
      <select id="department" className="swal2-select" style="width: 260px; height:50px"  autoFocus>
        <option value="" disabled selected>Select the department</option>
        ${departments.map(departments => `<option value="${departments.dept_id}">${departments.dept_name}</option>`).join('')}
      </select>
      <input id="firstname" class="swal2-input" placeholder="Enter first name" autofocus>
      <input id="lastname" class="swal2-input" placeholder="Enter last name" autofocus>
      <select id="leavepolicy" className="swal2-select" style="width: 260px; height:50px; margin-top: 20px"  autoFocus>
        <option value="" disabled selected>Select Leave Policy</option>
        ${LeavePolicy.map(LeavePolicy => `<option value="${LeavePolicy.leave_policy_id}">${LeavePolicy.leave_policy_name}</option>`).join('')}
      </select>
      <input id="loginuseremail" class="swal2-input" placeholder="Enter login user email" autofocus>
      <input id="userpassword" class="swal2-input" placeholder="Enter user password" autofocus>
      `,
      preConfirm: async () => {
        const department = Swal.getPopup().querySelector('#department').value;
        const leave_policy = Swal.getPopup().querySelector('#leavepolicy').value;
        const firstname = Swal.getPopup().querySelector('#firstname').value;
        const lastname = Swal.getPopup().querySelector('#lastname').value;
        const loginuseremail = Swal.getPopup().querySelector('#loginuseremail').value;
        const userpassword = Swal.getPopup().querySelector('#userpassword').value;

        if (!firstname || !lastname || !loginuseremail || !userpassword || !department) {
          Swal.showValidationMessage('Please fill in all the fields');
          console.error('Please fill in all the fields');

          return { success: false, message: 'Please fill in all the fields' };
        }

        const OrgID = getOrgId();
        const UserId = getUserId();
        const requestBody = {
          organization_id: OrgID,
          added_by: UserId,
          department: department,
          leave_policy: leave_policy,
          first_name: firstname,
          last_name: lastname,
          login_email_address: loginuseremail,
          users_password: userpassword,
        };

        try {

          const response = await fetch(AddExtrnalUser, {
            method: 'POST',
            headers: HEADERS,
            body: JSON.stringify(requestBody),
          });

          // $&

          if (response.ok) {
            const result = await response.json();

            if (result.response_code === '0000') {
              // Success
              setData([...data, result]);
              // $&

              window.location.reload();
              return {
                firstname,
                lastname,
                loginuseremail,
                userpassword,
                success: true,
                message: result.response_description,
              };
            } else {
              // Failure
              console.error('Failed to add External user');
              return { success: false, message: result.response_description };
            }
          } else {
            // Handle non-OK response (e.g., network error)
            console.error('Failed to communicate with the server');
            return { success: false, message: 'Failed to communicate with the server' };
          }
        } catch (error) {
          console.error('Error during External user creation:', error);
          return { success: false, message: 'Error during External user creation' };
        }
      },

    });

    if (isConfirmed) {
      const { success, message } = formValues;
      Swal.fire(
        success ? 'Added!' : 'Failed!',
        success ? 'External user has been added.' : `Failed to add External user. ${message}`,
        success ? 'success' : 'error'
      );
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      const OrgID = getOrgId();

      try {
        // External user
        const requestData = { org_id: OrgID };
        const response = await axios.post(GetExternalUser, requestData, { headers: HEADERS });
        console.log("response:", response.data)

        if (response.data.response_code === '0000') {
          setExtUser(response.data.data);
        } else {
          console.error('Error fetching external user. Please try again later.');
        }

        // Fetch department
        const requestBody = { org_id: OrgID };
        const resBody = await axios.post(GetLeavePolicy, requestBody, { headers: HEADERS });
        console.log("response:", resBody.data)

        if (resBody.data.response_code === '0000') {
          // $&
          setLeavePolicy(resBody.data.leave_policy);
        } else {
          console.error('Error fetching leave policy. Please try again later.');
        }

        // Fetch leave policy
        const reqData = { org_id: OrgID };
        const res = await axios.post(GetDepartment, reqData, { headers: HEADERS });
        console.log("response:", res.data)

        if (res.data.response_code === '0000') {
          // $&
          setDepartment(res.data.departments);
        } else {
          console.error('Error fetching departments. Please try again later.');
        }

      } catch (error) {
        console.error('An error occurred while fetching departments:', error);
      }
    };

    fetchData();
  }, []);


  const EditExternalUserBtn = async (userId) => {

    try {
      const externalUser = ExternalUser.find((user) => user.user_id === userId);
      // $&
      // $&

      // Get unique departments from external user data
      const uniqueDepartments = Array.from(new Set(ExternalUser.map(user => user.department)));

      const result = await Swal.fire({
        title: 'Edit External User',
        showCancelButton: true,
        confirmButtonText: 'Update',
        cancelButtonText: 'Cancel',
        html: `
        <select id="department" className="swal2-select" style="width: 260px; height:50px"  autoFocus>
          <option value="${externalUser.department}" selected>${externalUser.department_name}</option>
          ${departments.map(departments => `<option value="${departments.dept_id}">${departments.dept_name}</option>`).join('')}
        </select>
        <input id="firstname" class="swal2-input" value="${externalUser.first_name}" autofocus>
        <input id="Lastname" class="swal2-input" value="${externalUser.last_name}" autofocus>
        <input id="loginuseremail" class="swal2-input" value="${externalUser.email}" autofocus>
        `,

        preConfirm: () => {

          const editFirstName = Swal.getPopup().querySelector('#firstname').value;
          const editLastName = Swal.getPopup().querySelector('#Lastname').value;
          const editLoginUserEmail = Swal.getPopup().querySelector('#loginuseremail').value;
          const editDepartment = Swal.getPopup().querySelector('#department').value;

          if (!editFirstName || !editLastName || !editLoginUserEmail || !editDepartment) {
            Swal.showValidationMessage('Please fill in all the fields');
            console.error('Please fill in all the fields');

            return { success: false, message: 'Please fill in all the fields' };
          }

          const requestBody = {
            external_user_id: userId,
            first_name: editFirstName,
            last_name: editLastName,
            login_email_address: editLoginUserEmail,
            department: editDepartment,
          };

          // $&
          return requestBody;
        },
      });

      if (result.isConfirmed) {
        const { value } = result;

        // Send the update request to the API
        const response = await axios.post(EditExternalUser, result.value, { headers: HEADERS });

        if (response.data.response_code === '0000') {
          const updatedExternalUsers = ExternalUser.map((user) =>
            user.external_user_id === userId ? { ...user, ...result.value } : user
          );
          setExternalUser(updatedExternalUsers);
          Swal.fire('Updated!', 'External User has been updated.', 'success');
          window.location.reload();

        } else {
          Swal.fire('Failed!', `Failed to update External User. ${response.data.response_description}`, 'error');
        }
      }
    }
    catch (error) {
      console.error('Error updating External User:', error);
      Swal.fire('Failed!', 'An error occurred while updating External User.', 'error');
    }
  };

  const handleDelete = async (ExeUsrId) => {
    try {
      const confirmDelete = await Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this user!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
      });

      if (confirmDelete.isConfirmed) {
        const response = await axios.post(DeleteExternalUser, { user_id: ExeUsrId }, { headers: HEADERS });

        if (response.data.response_code === '0000') {
          Swal.fire('Deleted!', 'External User has been deleted.', 'success');
          window.location.reload();

        } else {
          Swal.fire('Failed!', 'Failed to delete the External User. Please try again later.', 'error');
          console.error('Error deleting external user. Please try again later.');
        }
      }
    } catch (error) {
      console.error('An error occurred while deleting external user:', error);
    }
  };

  const tableData = ExternalUser.map((external_user) => ({
    first_name: external_user.first_name,
    last_name: external_user.last_name,
    full_name: `${external_user.first_name} ${external_user.last_name}`,


    edit: (
      <Link onClick={() => EditExternalUserBtn(external_user.user_id)}>
        <FontAwesomeIcon icon={faEdit} style={{ cursor: 'pointer' }} />
      </Link>
    ),
    delete: <FontAwesomeIcon icon={faTrash} style={{ cursor: 'pointer' }} onClick={() => handleDelete(external_user.user_id)} />,
  }));

  const tableColumns = [
    {
      accessorKey: 'full_name',
      header: 'External User',
    },
    {
      accessorKey: 'edit',
      header: 'Edit',
    },
    {
      accessorKey: 'delete',
      header: 'Delete',
    },

  ];

  return (
    <Container fluid>
      <Grid>
        <Grid.Col xs={12}>
          <div>
            <span className='breachCrumb'>
              <Link to="/user-setting-dashboard">Setting</Link> /{' '}
              <Link to="/user-setting-dashboard/external1">External User</Link>
            </span>
          </div>
          <div className="headerSection">
            <h5>External User</h5>
            <button className="button-outline" onClick={AddExternalUsers}>
              Add External User
            </button>
          </div>
        </Grid.Col>
        <Grid.Col xs={12}>
          <div className="tab">
            <MantineReactTable
              columns={tableColumns}
              data={tableData}
              responsiveLayout={{ breakpoint: 'sm' }}
              enableFullScreenToggle={false}
            />
          </div>
        </Grid.Col>
      </Grid>
    </Container>
  );
}




